

dojo.require("wc.service.common");
dojo.require("dijit.registry");

shoppingActionsServicesDeclarationJS = {
	langId: "-1", 
	storeId: "", 
	catalogId: "", 

	setCommonParameters:function(langId,storeId,catalogId){
			this.langId = langId;
			this.storeId = storeId;
			this.catalogId = catalogId;
	}
}

	wc.service.declare({
		id: "AddOrderItem",
		actionId: "AddOrderItem",
		url: getAbsoluteURL() + "AjaxOrderChangeServiceItemAdd",
		formId: ""


		,successHandler: function(serviceResponse) {

				setTimeout(function()
				{
					$('#mini-cart').css('visibility', 'visible');
					var miniCartActiveItem = "<div class=\"mini-cart-active-item\"><span class=\"glyphicon glyphicon-ok\"></span> Item successfully added to cart.</div>";
					$('.mini-cart-item').first().append(miniCartActiveItem);

										setTimeout(function()
							{
								$('#mini-cart').css('visibility', 'hidden');
								$('div.mini-cart-active-item').remove();
							},3000
					);
				},1000);

						var AT_PDP_ADDTOCARTMODAL = sessionStorage.getItem("AT_PDP_ADDTOCARTMODAL");
		var testFlow = AT_PDP_ADDTOCARTMODAL ? AT_PDP_ADDTOCARTMODAL : "var_A";
		try{
			var omnitureEnabled;
			if(null != $('#omnitureEnabled') && undefined != $('#omnitureEnabled'))
				omnitureEnabled = $('#omnitureEnabled').val();
			if(omnitureEnabled != "undefined" && null != omnitureEnabled && omnitureEnabled !='' && omnitureEnabled == 'true'){
				var catalogEntryId = productDisplayJS.getCatalogEntryId("entitledItem_"+productDisplayJS.baseCatalogEntryId);
				var cartEventDetails = {};
				if(catalogEntryId != null){
					var catEntry = productDisplayJS.itemPriceJsonOject[catalogEntryId].catalogEntry;
					var partNumb = catEntry.catalogEntryIdentifier.externalIdentifier.partNumber;
					var quantity = shoppingActionsJS.productAddedList[catalogEntryId][3];
					var cartOrderId = dojo.cookie("WC_CartOrderId_10151");
					var elementId = '';
					if(cartOrderId == '' || cartOrderId == null || cartOrderId == 'undefined'){
						cartEventDetails["event_name"] = "cart_open";
						cartEventDetails["cart_id"] = serviceResponse.orderId[0];
						elementId='add2CartBtn_cpy1';
					}else{
						cartEventDetails["event_name"] = "cart_add";
						cartEventDetails["cart_id"] = cartOrderId;
						elementId='add2CartBtn_cpy1';
					}
					cartEventDetails["product_id"] = catalogEntryId;
					cartEventDetails["product_sku"] = catEntry.catalogEntryIdentifier.externalIdentifier.partNumber;
					cartEventDetails["product_name"] = catEntry.description[0].name;
					cartEventDetails["add_to_cart_quantity"] = quantity;
					if(null != $('#tel_product_id') && undefined != $('#tel_product_id')){
						cartEventDetails["product_parent_sku"] = $('#tel_product_id').val();
					}
					var repeatDeliveryOption = $('#repeat-delivery-radio');					
					if(repeatDeliveryOption!=null || repeatDeliveryOption!=undefined)
					{
		    		   if(repeatDeliveryOption && repeatDeliveryOption.is(':checked')){
		    			   cartEventDetails["product_delivery_type"] = "repeat";
		    			   cartEventDetails["product_rd_schedule"] = "yes";
		    			   if($('#repeat-delivery-freq-options')!=null || $('#repeat-delivery-freq-options')!=undefined){
		    				   cartEventDetails["product_rd_schedule_time"] = $('#repeat-delivery-freq-options').val();	
		    			   }	  
		    			   elementId='add2CartBtn_cpy2';
		    		   }
					}
					if($('#one-time-delivery').is(':checked')){
						cartEventDetails["product_delivery_type"] = "one time";
					}
					if($('#store-pickup').is(':checked')){
						cartEventDetails["product_delivery_type"] = "bopus";
					}
				}
				if(testFlow != "var_B"){
					pushEvent(cartEventDetails,elementId);
				} else {
					window.PetcoDataLayer = window.PetcoDataLayer || {};
					window.PetcoDataLayer["events"] = cartEventDetails;
				}
			}

					}catch(err){
			console.log(err);
		}
		if(document.getElementById("headerShopCartLink")&&document.getElementById("headerShopCartLink").style.display != "none")
		{
			document.getElementById("headerShopCart").focus();
		}
		else
		{
			if(document.getElementById("headerShopCart1")){
				document.getElementById("headerShopCart1").focus();
			}
		}

					dojo.require("dijit.registry");
			MessageHelper.hideAndClearMessage();
			cursor_clear();
			if(productDisplayJS.isRepeatDeliveryProduct)
			{
				document.getElementById('repearDeliveryItemIds').value = document.getElementById('repearDeliveryItemIds').value + "_"+productDisplayJS.selectedCatalogEntryId;
			}
			else
			{
				if(document.getElementById('oneTimeDeliveryItemIds')!=null){
					document.getElementById('oneTimeDeliveryItemIds').value = document.getElementById('oneTimeDeliveryItemIds').value + "_"+productDisplayJS.selectedCatalogEntryId;
				}

							}
			if(document.getElementById('allProductIds')!=null){
				document.getElementById('allProductIds').value = document.getElementById('allProductIds').value + "_"+productDisplayJS.selectedCatalogEntryId;
			}


									if(shoppingActionsJS){

								var attributes_container = dojo.query('div[id^="attrValue_"]');

								if ((dojo.query(".definingAttributes")[0]) != null) {
					var attributes_container = dojo.query(".definingAttributes");	
				}
				else if ((dojo.query(".product_sizes")[0]) != null) {
					var attributes_container = dojo.query(".product_sizes");
				}
				else if ((dojo.query(".product_info")[0]) != null) {
					var attributes_container = dojo.query(".product_info");
				}

								var attributes = new Array();
				for (var i = 0; i < attributes_container.length; i++) {
					var attribute_selectors = attributes_container[i].querySelectorAll(".dijitSelect");
					for (var j = 0; j < attribute_selectors.length; j++) {
						attributes = attributes.concat(attribute_selectors[j]);
					}
				}

								var dijitSelect = new Array();
				for (var i = 0; i < attributes.length; i++) {
					dijitSelect[i] = dijit.registry.byNode(attributes[i]);
				}

								var singleSKU = true;
				for(var i=0; i<dijitSelect.length; i++){
					if (dijitSelect[i].options.length > 2)
					{
						singleSKU = false;
					}
				}

								if (!singleSKU)
				{
					shoppingActionsJS.selectedAttributes = new Object();
					dojo.topic.publish('DefiningAttributes_Resolved_'+shoppingActionsJS.baseCatalogEntryId, shoppingActionsJS.baseCatalogEntryId, -1);
					for(var i=0; i<dijitSelect.length; i++){
						if(dijitSelect[i] != null){
							dijitSelect[i].value = "";
						}
					}
				}

							}
			if(typeof(ShipmodeSelectionExtJS)!= null && typeof(ShipmodeSelectionExtJS)!='undefined'){
				ShipmodeSelectionExtJS.setOrderItemId(serviceResponse.orderItemId[0]);
			}
			dojo.publish("CMAddToCart");

						var isMembershipV2Enabled = $("#isMembershipV2Enabled").val();

			if(typeof(productDisplayJS) != "undefined" && document.getElementById("isCartInterstialEnabled") != undefined 
					&& document.getElementById("isCartInterstialEnabled") != null
					&& document.getElementById("isCartInterstialEnabled").value == 'Yes'){
				if(serviceResponse.membershipItemAddFlag != null && serviceResponse.membershipItemAddFlag != undefined && serviceResponse.membershipItemAddFlag == 'true') {
					var catentryId = productDisplayJS.baseCatalogEntryId;
				} else {
					var catentryId = productDisplayJS.getCatalogEntryId(productDisplayJS.baseCatalogEntryId);
				}
						document.location.href = getAbsoluteURL() +"PetcoAddToCartLandingPageView?langId=" + shoppingActionsServicesDeclarationJS.langId + "&catalogId=" + shoppingActionsServicesDeclarationJS.catalogId + "&storeId=" + shoppingActionsServicesDeclarationJS.storeId + "&catentryId=" + productDisplayJS.baseCatalogEntryId + "&selectCatentryId=" + catentryId + "&orderItemId=" + serviceResponse.orderItemId[0];
			}else if(typeof(productDisplayJS) != "undefined" && document.getElementById("isATCABTestEnabled") != undefined 
					&& document.getElementById("isATCABTestEnabled") != null && document.getElementById("isATCABTestEnabled").value != ''){
				if(testFlow == "var_B"){
					var poupOrdItmId=serviceResponse.orderItemId[0];
					var catentryId =  productDisplayJS.getCatalogEntryId("entitledItem_"+productDisplayJS.baseCatalogEntryId);
					wc.render.updateContext("PetcoInterstitialCartPopUpAreaContext",{'orderItemId':poupOrdItmId,'quantity':shoppingActionsJS.productAddedList[catalogEntryId][3]},"");
				}else{
					if(isMembershipV2Enabled != undefined && isMembershipV2Enabled != null && isMembershipV2Enabled != "" && isMembershipV2Enabled == "true"){
						document.location.href = getAbsoluteURL() + "OrderCalculate?calculationUsageId=-1&calculationUsageId=-2&calculationUsageId=-7&calculationUsageId=-6&calculationUsageId=-12&orderId=.&langId="+ shoppingActionsServicesDeclarationJS.langId + "&catalogId=" + shoppingActionsServicesDeclarationJS.catalogId + "&storeId=" + shoppingActionsServicesDeclarationJS.storeId + "&errorViewName=AjaxOrderItemDisplayView&callToODM=true&updatePrices=1&URL=" + encodeURIComponent(getAbsoluteURL() + "OrderCalculate?calculationUsageId=-1&calculationUsageId=-7&orderId=.&langId="+ shoppingActionsServicesDeclarationJS.langId + "&catalogId=" + shoppingActionsServicesDeclarationJS.catalogId + "&storeId=" + shoppingActionsServicesDeclarationJS.storeId + "&errorViewName=AjaxOrderItemDisplayView&callToODM=false&updatePrices=1&URL="+encodeURIComponent(getAbsoluteURL() + "OrderItemDisplay?doInventory=Y&orderId=.&langId="+ shoppingActionsServicesDeclarationJS.langId + "&catalogId=" + shoppingActionsServicesDeclarationJS.catalogId + "&storeId=" + shoppingActionsServicesDeclarationJS.storeId));
					}else{
						document.location.href = getAbsoluteURL() + "OrderCalculate?calculationUsageId=-1&calculationUsageId=-2&calculationUsageId=-7&calculationUsageId=-6&orderId=.&langId="+ shoppingActionsServicesDeclarationJS.langId + "&catalogId=" + shoppingActionsServicesDeclarationJS.catalogId + "&storeId=" + shoppingActionsServicesDeclarationJS.storeId + "&errorViewName=AjaxOrderItemDisplayView&callToODM=true&updatePrices=1&URL=" + encodeURIComponent(getAbsoluteURL() + "OrderCalculate?calculationUsageId=-1&calculationUsageId=-7&orderId=.&langId="+ shoppingActionsServicesDeclarationJS.langId + "&catalogId=" + shoppingActionsServicesDeclarationJS.catalogId + "&storeId=" + shoppingActionsServicesDeclarationJS.storeId + "&errorViewName=AjaxOrderItemDisplayView&callToODM=false&updatePrices=1&URL="+encodeURIComponent(getAbsoluteURL() + "OrderItemDisplay?doInventory=Y&orderId=.&langId="+ shoppingActionsServicesDeclarationJS.langId + "&catalogId=" + shoppingActionsServicesDeclarationJS.catalogId + "&storeId=" + shoppingActionsServicesDeclarationJS.storeId));
					}
				}				
			}else{
				if(isMembershipV2Enabled != undefined && isMembershipV2Enabled != null && isMembershipV2Enabled != "" && isMembershipV2Enabled == "true"){
					document.location.href = getAbsoluteURL() + "OrderCalculate?calculationUsageId=-1&calculationUsageId=-2&calculationUsageId=-7&calculationUsageId=-6&calculationUsageId=-12&orderId=.&langId="+ shoppingActionsServicesDeclarationJS.langId + "&catalogId=" + shoppingActionsServicesDeclarationJS.catalogId + "&storeId=" + shoppingActionsServicesDeclarationJS.storeId + "&errorViewName=AjaxOrderItemDisplayView&callToODM=true&updatePrices=1&URL=" + encodeURIComponent(getAbsoluteURL() + "OrderCalculate?calculationUsageId=-1&calculationUsageId=-7&orderId=.&langId="+ shoppingActionsServicesDeclarationJS.langId + "&catalogId=" + shoppingActionsServicesDeclarationJS.catalogId + "&storeId=" + shoppingActionsServicesDeclarationJS.storeId + "&errorViewName=AjaxOrderItemDisplayView&callToODM=false&updatePrices=1&URL="+encodeURIComponent(getAbsoluteURL() + "OrderItemDisplay?doInventory=Y&orderId=.&langId="+ shoppingActionsServicesDeclarationJS.langId + "&catalogId=" + shoppingActionsServicesDeclarationJS.catalogId + "&storeId=" + shoppingActionsServicesDeclarationJS.storeId));
				}else{
					document.location.href = getAbsoluteURL() + "OrderCalculate?calculationUsageId=-1&calculationUsageId=-2&calculationUsageId=-7&calculationUsageId=-6&orderId=.&langId="+ shoppingActionsServicesDeclarationJS.langId + "&catalogId=" + shoppingActionsServicesDeclarationJS.catalogId + "&storeId=" + shoppingActionsServicesDeclarationJS.storeId + "&errorViewName=AjaxOrderItemDisplayView&callToODM=true&updatePrices=1&URL=" + encodeURIComponent(getAbsoluteURL() + "OrderCalculate?calculationUsageId=-1&calculationUsageId=-7&orderId=.&langId="+ shoppingActionsServicesDeclarationJS.langId + "&catalogId=" + shoppingActionsServicesDeclarationJS.catalogId + "&storeId=" + shoppingActionsServicesDeclarationJS.storeId + "&errorViewName=AjaxOrderItemDisplayView&callToODM=false&updatePrices=1&URL="+encodeURIComponent(getAbsoluteURL() + "OrderItemDisplay?doInventory=Y&orderId=.&langId="+ shoppingActionsServicesDeclarationJS.langId + "&catalogId=" + shoppingActionsServicesDeclarationJS.catalogId + "&storeId=" + shoppingActionsServicesDeclarationJS.storeId));
				}
			}	
		}
		,failureHandler: function(serviceResponse) {

			if (serviceResponse.errorMessage) {
			 	if(serviceResponse.errorMessageKey == "_ERR_NO_ELIGIBLE_TRADING"){
			 		MessageHelper.displayErrorMessage(storeNLS["ERROR_CONTRACT_EXPIRED_GOTO_ORDER"]);
 				} else if (serviceResponse.errorMessageKey == "_ERR_PRICE_MAXQUANTITY") {
 					var tempString = serviceResponse.errorMessage; 					
 					petcoCommonJS.showModalNotificationAlert(tempString);
 					cursor_clear();
 					return false;
 				}else if (serviceResponse.errorMessageKey == "_ERR_RETRIEVE_PRICE") {
					var tempString = storeNLS["GENERICERR_MAINTEXT"];
					tempString = dojo.string.substitute(tempString,{0:storeNLS["GENERICERR_CONTACT_US"]});
 					MessageHelper.displayErrorMessage(tempString);
 				} 
 				else if(serviceResponse.errorMessageKey == "_ERR_EXISTING_PRODUCT_IS_REPEAT_DELIVERY_PRODUCT" )
 				{
 					var tempString = storeNLS["ERR_EXISTING_PRODUCT_IS_REPEAT_DELIVERY_PRODUCT"]; 					
 					petcoCommonJS.showModalNotificationAlert(tempString);
 					cursor_clear();
 					return false;
 				}
 				else if(serviceResponse.errorMessageKey == "_ERR_EXISTING_PRODUCT_IS_ONETIME_DELIVERY_PRODUCT" )
 				{
 					var tempString = storeNLS["ERR_EXISTING_PRODUCT_IS_ONETIME_DELIVERY_PRODUCT"]; 					
 					petcoCommonJS.showModalNotificationAlert(tempString);
 					cursor_clear();
 					return false;
 				}
 				else if( serviceResponse.errorMessageKey == "_ERR_MEMBERSHIP_ITEM_EXIT_IN_CART" || serviceResponse.errorMessageKey == "_ERR_ALREADY_WHMEMBERSHIPMEMBER")
 				{
 					petcoCommonJS.showModalNotificationAlert(serviceResponse.errorMessage);
 					cursor_clear();
 					return false;
 				}
 				else {
 					MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
 				}
			} 
			else {
				 if (serviceResponse.errorMessageKey) {
					MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
				 }
			}
			cursor_clear();
		}

	}),

	wc.service.declare({
		id: "AddPreConfigurationToCart",
		actionId: "AddOrderItem",
		url: getAbsoluteURL() + "AjaxOrderChangeServiceAddPreConfigurationToCart",
		formId: ""


		,successHandler: function(serviceResponse) {
			MessageHelper.hideAndClearMessage();
			cursor_clear();
			if(shoppingActionsJS){

								var attributes = document.getElementsByName("attrValue");

							var singleSKU = true;

								for(var i=0; i<attributes.length; i++){
					if (attributes[i].options.length > 1)
					{
						singleSKU = false;
					}
				}

								if (!singleSKU)
				{
					shoppingActionsJS.selectedAttributes = new Object();
					for(var i=0; i<attributes.length; i++){
						if(attributes[i] != null){
							attributes[i].value = "";
							attributes[i].onchange();
						}
					}
				}
			}
			if(typeof(ShipmodeSelectionExtJS)!= null && typeof(ShipmodeSelectionExtJS)!='undefined'){
				ShipmodeSelectionExtJS.setOrderItemId(serviceResponse.orderItemId[0]);
			}
		}
		,failureHandler: function(serviceResponse) {

			if (serviceResponse.errorMessage) {
			 	if(serviceResponse.errorMessageKey == "_ERR_NO_ELIGIBLE_TRADING"){
			 		MessageHelper.displayErrorMessage(storeNLS["ERROR_CONTRACT_EXPIRED_GOTO_ORDER"]);
 				} else if (serviceResponse.errorMessageKey == "_ERR_RETRIEVE_PRICE") {
					var tempString = storeNLS["GENERICERR_MAINTEXT"];
					tempString = dojo.string.substitute(tempString,{0:storeNLS["GENERICERR_CONTACT_US"]});
 					MessageHelper.displayErrorMessage(tempString);
 				} else {
 					MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
 				}
			} 
			else {
				 if (serviceResponse.errorMessageKey) {
					MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
				 }
			}
			cursor_clear();
		}

	}),

	wc.service.declare({
		id: "AjaxAddPayPalInstructionToThisOrder",
		actionId: "AjaxAddPaymentInstructionToThisOrder",
		url: "AjaxOrderChangeServicePIAdd",
		formId: ""


						,successHandler: function(serviceResponse) {	
		    var piID = '';
		    piID = serviceResponse.piId;
			if(piID.toString().split(",").length-1 > 0)
			{
			 document.PayPalForm.piId.value = piID.toString().split(",")[piID.toString().split(",").length-1];
			}
			else
			{	
			 document.PayPalForm.piId.value = serviceResponse.piId;
			}
			document.PayPalForm.submit();

					}

				,failureHandler: function(serviceResponse) {
			window.location.href = window.location.href;
		}

	}),
	wc.service.declare({
		id: "AjaxDeletePayPalPaymentInstructionFromThisOrder",
		actionId: "AjaxDeletePaymentInstructionFromThisOrder",
		url: "AjaxOrderChangeServicePIDelete",
		formId: ""

		,successHandler: function(serviceResponse) {
			if(document.getElementById("isRDOrder") !='undefined' && document.getElementById("payPalUserType") !='undefined' ){
				if(document.getElementById("isRDOrder").value == 'true' && document.getElementById("payPalUserType").value == 'G'){
					window.location.href = document.getElementById("LogonURL").value;
					return;
				}
			}
			shoppingActionsJS.addPayPalPaymentInstructions();
	     }

				,failureHandler: function(serviceResponse) {
			alert('Failed to Delete the existing PayPal Instruction before invoking the same');
		}

	}),

	wc.service.declare({
		id: "RepeatDeliveryOrderAdd",
		actionId: "RepeatDeliveryOrderAdd",
		url: getAbsoluteURL() + "AjaxPetcoRepeatDeliveryOrderAdd",
		formId: ""


		,successHandler: function(serviceResponse) {
			var childNextFfmDate = null;
			var childTemplateOrderId = null;
			var childSubscriptionId = null;
			var nextFfmDateElem = null;
			var childFfmFrequency= null;

			cursor_clear();
			childNextFfmDate = serviceResponse.childNextFfmDate;
			childTemplateOrderId = serviceResponse.childTemplateOrderId;
			childSubscriptionId = serviceResponse.childSubscriptionId;
			childFfmFrequency = serviceResponse.childFfmFrequency;

			try{
				var catalogEntryId = productDisplayJS.getCatalogEntryId("entitledItem_"+productDisplayJS.baseCatalogEntryId);
				var catEntry = productDisplayJS.itemPriceJsonOject[catalogEntryId].catalogEntry;
				var partNumb = catEntry.catalogEntryIdentifier.externalIdentifier.partNumber;

								var omnitureEnabled;
				if(null != $('#omnitureEnabled') && undefined != $('#omnitureEnabled'))
					omnitureEnabled = $('#omnitureEnabled').val();
				if(omnitureEnabled != "undefined" && null != omnitureEnabled && omnitureEnabled !='' && omnitureEnabled == 'true'){
					var cartEventDetails = {};
					if(catalogEntryId != null){
						var quantity = shoppingActionsJS.productAddedList[catalogEntryId][3];
						var cartOrderId = dojo.cookie("WC_CartOrderId_10151");


												cartEventDetails["event_name"] = "add_to_existing_rd";
						cartEventDetails["product_id"] = catalogEntryId;
						cartEventDetails["product_sku"] = catEntry.catalogEntryIdentifier.externalIdentifier.partNumber;
						var name = catEntry.description[0].name;
						var productName = name.replace(/["']/g, "");
						cartEventDetails["product_name"] = productName;
						cartEventDetails["add_to_cart_quantity"] = quantity;
						var repeatDeliveryOption = $('#repeat-delivery-radio');
						if(null != $('#tel_product_id') && undefined != $('#tel_product_id')){
							cartEventDetails["product_parent_sku"] = $('#tel_product_id').val();
						}
						if(serviceResponse.subscriptionId != null && serviceResponse.subscriptionId[0] != null) {
							cartEventDetails["subscription_id"] = serviceResponse.subscriptionId[0];
							cartEventDetails["product_delivery_type"] = "recurring";
						}
						if(repeatDeliveryOption!=null || repeatDeliveryOption!=undefined)
						{
			    		   if(repeatDeliveryOption && repeatDeliveryOption.is(':checked')){
			    			   cartEventDetails["product_delivery_type"] = "recurring";
			    			   cartEventDetails["product_rd_schedule"] = "yes";
			    			   if($('#repeat-delivery-freq-options')!=null || $('#repeat-delivery-freq-options')!=undefined){
			    				   cartEventDetails["product_rd_schedule_time"] = $('#repeat-delivery-freq-options').val();	
			    			   }	  
			    		   }
						}
						if($('#one-time-delivery').is(':checked')){
							cartEventDetails["product_delivery_type"] = "one time";
						}
						if(serviceResponse.fulfillmentInterval && serviceResponse.fulfillmentInterval == "1"){
							cartEventDetails["product_delivery_type"] = "one time";
						}
						if($('#store-pickup').is(':checked')){
							cartEventDetails["product_delivery_type"] = "bopus";
						}
					}
					pushEvent(cartEventDetails);
				}
			}catch(err){
				console.log(err);
			}
			if (serviceResponse.action == "isAddOn") {
				var params = {};
				params["childSubscriptionId"] = childSubscriptionId;
				params["catalogEntryId"] = catalogEntryId;	
				params["nextffmtdate"] = childNextFfmDate;
				PetcoRepeatDeliveryAddOnJS.updateContextonRDAddOnConfirmation(params);

				$('#add_on_rd_option').modal('hide')
				$('#add_on_rd_conf').modal('show');
				nextFfmDateElem = dojo.byId('add_on_rd_conf_nextffmtdate');
				nextFfmDateElem.innerHTML = childNextFfmDate;
				var rd_sku = serviceResponse.rdSkuPartNumber;
				try{
				if (rd_sku != null && rd_sku != "undefined") {
					var name = catEntry.description[0].name;
					var productName = name.replace(/["']/g, "");
					var product_parent_sku;
					if(null != $('#tel_product_id') && undefined != $('#tel_product_id')){
						  product_parent_sku = $('#tel_product_id').val();
						}
					var subscription_id;
					if(serviceResponse.subscriptionId != null && serviceResponse.subscriptionId[0] != null) {
						subscription_id = serviceResponse.subscriptionId[0];
					}
					var productionRDJSON = {"product_id" : catalogEntryId, "subscription_id" : subscription_id, "product_name" : productName, "event_name" : "add_to_existing_rd", "product_rd_schedule_time" : "one time delivery", "product_delivery_type" : "one time", "product_sku" : rd_sku, "product_parent_sku" : product_parent_sku};
					pushEvent(productionRDJSON);
					}
					buildModalDataLayer('add once to repeat delivery','modal_close');
					buildModalDataLayer('add once to repeat delivery confirm','modal_show');
				}
				catch(err){
					console.log(err);
				}
			} else if (serviceResponse.action == "isInclusive") {
				$('#add_to_rd_option').modal('hide');

								if($('#modal-rxmedicine-perscription-details').length){
					petcoCommonJS.hideModal('modal-rxmedicine-perscription-details');
				}
				$('#add_to_rd_conf').modal('show');

								try {
					buildModalDataLayer('add to repeat delivery','modal_close');
					buildModalDataLayer('add to repeat delivery confirm','modal_show');
				} catch (err) {
					console.log(err);
				}

								var addToRDDropDown= $('#addToRDDropDown').val();
				if(addToRDDropDown != "undefined" && null != addToRDDropDown && addToRDDropDown !='' && addToRDDropDown == 'ADDON'){
					$('#addOnceToRDSuccessLabel').show();
					nextFfmDateElem = dojo.byId('add_on_rd_conf_nextffmtdate');
					nextFfmDateElem.innerHTML = childNextFfmDate;
				}else if(addToRDDropDown != "undefined" && null != addToRDDropDown && addToRDDropDown !='' && addToRDDropDown == 'INC'){
					$('#addToRDSuccessLabel').show();
					nextFfmDateElem = dojo.byId('add_to_rd_conf_nextffmtdate');
					nextFfmDateElem.innerHTML = childNextFfmDate;

										var nextFfmFrequencyElem = dojo.byId('add_to_rd_conf_frequency');
					nextFfmFrequencyElem.innerHTML = childFfmFrequency;
				}

											}else if (serviceResponse.action == "addItemToRD"){
				window.location.reload(true);		
				$(window).scrollTop(0);
			}

			var aParams=[];
			aParams.langId =shoppingActionsServicesDeclarationJS.langId;
			aParams.storeId = shoppingActionsServicesDeclarationJS.storeId;
			aParams.catalogId = shoppingActionsServicesDeclarationJS.catalogId;
			aParams.updateCookies = true;
			wc.service.invoke("AjaxPetcoPalsRewardsPointsSubscription",aParams);

				}

		,failureHandler: function(serviceResponse) {
			cursor_clear();
			if($('#modal-addToRD').length > 0){
				petcoCommonJS.showModal('modal-addToRD');
			}
			if (serviceResponse.errorMessageKey && serviceResponse.errorMessageKey == "_ERR_RD_ORDER_ADD_PAYMENT_METHOD_INVALID") {
				$("#add2RDordermsg").text(MessageHelper.messages["ADD_ON_MODAL_FAILURE_EXPIRED_CC"]);
				$("#add2RDordermsg").addClass("show");      
				$("#add2RDOrderBtn").addClass("disabled");
			}else if(serviceResponse.errorMessageKey && serviceResponse.errorMessageKey == "_ERR_PRICE_MAXQUANTITY"){
				$("#add2RDordermsg").text(serviceResponse.errorMessage);
				$("#add2RDordermsg").addClass("show");      
				$("#add2RDOrderBtn").addClass("disabled");
			}
			else if (serviceResponse.errorMessage) {
				$("#add2RDordermsg").text(MessageHelper.messages["ADD_ON_MODAL_FAILURE_OTHER"]);
				$("#add2RDordermsg").addClass("show");
				$("#add2RDOrderBtn").addClass("disabled");
			}
		}
	}),

	wc.service.declare({
		id: "AddRecurringOrderItem",
		actionId: "AddRecurringOrderItem",
		url: getAbsoluteURL() + "AjaxPetcoRecurringOrderItemAdd",
		formId: ""


		,successHandler: function(serviceResponse) {

						var orderId = serviceResponse.orderId;

					}

		,failureHandler: function(serviceResponse) {

		}
	});
wc.service.declare({
	id: "AddOrderItemAddService",
	actionId: "AddOrderItemAddService",
	url: getAbsoluteURL() + "AjaxOrderChangeServiceItemAdd",
	formId: ""


 		,successHandler: function(serviceResponse) {

				setTimeout(function()
				{
					$('#mini-cart').css('visibility', 'visible');
					var miniCartActiveItem = "<div class=\"mini-cart-active-item\"><span class=\"glyphicon glyphicon-ok\"></span> Item successfully added to cart.</div>";
					$('.mini-cart-item').first().append(miniCartActiveItem);

										setTimeout(function()
							{
								$('#mini-cart').css('visibility', 'hidden');
								$('div.mini-cart-active-item').remove();
							},3000
					);
				},1000);	

				if(document.getElementById("headerShopCartLink")&&document.getElementById("headerShopCartLink").style.display != "none")
		{
			document.getElementById("headerShopCart").focus();
		}
		else
		{
			if(document.getElementById("headerShopCart1")){
				document.getElementById("headerShopCart1").focus();
			}
		}

					dojo.require("dijit.registry");
			MessageHelper.hideAndClearMessage();			
			cursor_clear();



												if(shoppingActionsJS){

								var attributes_container = dojo.query('div[id^="attrValue_"]');

								if ((dojo.query(".definingAttributes")[0]) != null) {
					var attributes_container = dojo.query(".definingAttributes");	
				}
				else if ((dojo.query(".product_sizes")[0]) != null) {
					var attributes_container = dojo.query(".product_sizes");
				}
				else if ((dojo.query(".product_info")[0]) != null) {
					var attributes_container = dojo.query(".product_info");
				}

								var attributes = new Array();
				for (var i = 0; i < attributes_container.length; i++) {
					var attribute_selectors = attributes_container[i].querySelectorAll(".dijitSelect");
					for (var j = 0; j < attribute_selectors.length; j++) {
						attributes = attributes.concat(attribute_selectors[j]);
					}
				}

								var dijitSelect = new Array();
				for (var i = 0; i < attributes.length; i++) {
					dijitSelect[i] = dijit.registry.byNode(attributes[i]);
				}

								var singleSKU = true;
				for(var i=0; i<dijitSelect.length; i++){
					if (dijitSelect[i].options.length > 2)
					{
						singleSKU = false;
					}
				}

								if (!singleSKU)
				{
					shoppingActionsJS.selectedAttributes = new Object();
					dojo.topic.publish('DefiningAttributes_Resolved_'+shoppingActionsJS.baseCatalogEntryId, shoppingActionsJS.baseCatalogEntryId, -1);
					for(var i=0; i<dijitSelect.length; i++){
						if(dijitSelect[i] != null){
							dijitSelect[i].value = "";
						}
					}
				}

							}
			if(typeof(ShipmodeSelectionExtJS)!= null && typeof(ShipmodeSelectionExtJS)!='undefined'){
				ShipmodeSelectionExtJS.setOrderItemId(serviceResponse.orderItemId[0]);
			}
			dojo.publish("CMAddToCart");


								if(typeof(productDisplayJS) != "undefined" && document.getElementById("isCartInterstialEnabled") != undefined 
					&& document.getElementById("isCartInterstialEnabled") != null
					&& document.getElementById("isCartInterstialEnabled").value == 'Yes'){

								var catentryId = productDisplayJS.getCatalogEntryId(productDisplayJS.baseCatalogEntryId);

										document.location.href = getAbsoluteURL() +"PetcoAddToCartLandingPageView?langId=" + shoppingActionsServicesDeclarationJS.langId + "&catalogId=" + shoppingActionsServicesDeclarationJS.catalogId + "&storeId=" + shoppingActionsServicesDeclarationJS.storeId + "&catentryId=" + productDisplayJS.baseCatalogEntryId + "&selectCatentryId=" + catentryId + "&orderItemId=" + serviceResponse.orderItemId[0];
			}else{

								document.location.href = getAbsoluteURL() + "OrderCalculate?calculationUsageId=-1&calculationUsageId=-2&calculationUsageId=-7&calculationUsageId=-6&orderId=.&langId="+ shoppingActionsServicesDeclarationJS.langId + "&catalogId=" + shoppingActionsServicesDeclarationJS.catalogId + "&storeId=" + shoppingActionsServicesDeclarationJS.storeId + "&errorViewName=AjaxOrderItemDisplayView&callToODM=true&updatePrices=1&URL=" + encodeURIComponent(getAbsoluteURL() + "OrderCalculate?calculationUsageId=-1&calculationUsageId=-7&orderId=.&langId="+ shoppingActionsServicesDeclarationJS.langId + "&catalogId=" + shoppingActionsServicesDeclarationJS.catalogId + "&storeId=" + shoppingActionsServicesDeclarationJS.storeId + "&errorViewName=AjaxOrderItemDisplayView&callToODM=false&updatePrices=1&URL="+encodeURIComponent(getAbsoluteURL() + "OrderItemDisplay?doInventory=Y&orderId=.&langId="+ shoppingActionsServicesDeclarationJS.langId + "&catalogId=" + shoppingActionsServicesDeclarationJS.catalogId + "&storeId=" + shoppingActionsServicesDeclarationJS.storeId));
			}	
		}
		,failureHandler: function(serviceResponse) {

			if (serviceResponse.errorMessage) {
			 	if(serviceResponse.errorMessageKey == "_ERR_NO_ELIGIBLE_TRADING"){
			 		MessageHelper.displayErrorMessage(storeNLS["ERROR_CONTRACT_EXPIRED_GOTO_ORDER"]);
 				} else if (serviceResponse.errorMessageKey == "_ERR_RETRIEVE_PRICE") {
					var tempString = storeNLS["GENERICERR_MAINTEXT"];
					tempString = dojo.string.substitute(tempString,{0:storeNLS["GENERICERR_CONTACT_US"]});
 					MessageHelper.displayErrorMessage(tempString);
 				} 
 				else if(serviceResponse.errorMessageKey == "_ERR_EXISTING_PRODUCT_IS_REPEAT_DELIVERY_PRODUCT" )
 				{
 					var tempString = storeNLS["ERR_EXISTING_PRODUCT_IS_REPEAT_DELIVERY_PRODUCT"]; 					
 					petcoCommonJS.showModalNotificationAlert(tempString);
 					cursor_clear();
 					return false;
 				}
 				else if(serviceResponse.errorMessageKey == "_ERR_EXISTING_PRODUCT_IS_ONETIME_DELIVERY_PRODUCT" )
 				{
 					var tempString = storeNLS["ERR_EXISTING_PRODUCT_IS_ONETIME_DELIVERY_PRODUCT"]; 					
 					petcoCommonJS.showModalNotificationAlert(tempString);
 					cursor_clear();
 					return false;
 				}
 				else if( serviceResponse.errorMessageKey == "_ERR_MEMBERSHIP_ITEM_EXIT_IN_CART" || serviceResponse.errorMessageKey == "_ERR_ALREADY_WHMEMBERSHIPMEMBER")
 				{
 					petcoCommonJS.showModalNotificationAlert(serviceResponse.errorMessage);
 					cursor_clear();
 					return false;
 				}
 				else {
 					MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
 				}
			} 
			else {
				 if (serviceResponse.errorMessageKey) {
					MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
				 }
			}
			cursor_clear();
		}
});

wc.service.declare({
	id: "AjaxHolidayShippingMsg",
	actionId: "AjaxHolidayShippingMsg",
	url: "AjaxHolidayShippingMsg",
	formId: "",
	successHandler: function(serviceResponse) {
		productDisplayJS.holidayPreCutOff = false;
		productDisplayJS.holidayMsgCallCompleted = false;
		var orders = serviceResponse.shipMsgResBeforeCutOff;
		for (var orderItem in orders) {
			console.log( "before cutoff "+orderItem + "::  " +  orders[orderItem] );
			if (serviceResponse.fromPDP == 'Y') {
				productDisplayJS.holidayPreCutOff = true;
				if (document.getElementById("ShippingMessage") != null) {
					document.getElementById("ShippingMessage").innerText = orders[orderItem];	
					$("#ShippingMessage").removeClass("hide");
					$("#ShippingMessage").addClass("sled-icon");
				}
				if(document.getElementById("deliveryDateMsg") != null){
					$("#deliveryDateMsg").addClass("hide");
					}
			} else {
					if (document.getElementById("shippingMsgContainer_" + orderItem) != null) {
						document.getElementById("shippingMsgContainer_" + orderItem).innerText = orders[orderItem];
						$("#shippingMsgContainer_" + orderItem).removeClass("hide");
						$("#shippingMsgContainer_" + orderItem).addClass("sled-icon");
						if(document.getElementById("deliveryDateMsg_" + orderItem) != null
								&& document.getElementById("orderdate_" + orderItem) != null
								&& "" != document.getElementById("orderdate_" + orderItem).innerText){
							$("#deliveryDateMsg_" + orderItem).addClass("hide");
						}
						if(document.getElementById("deliveryDateMsgMobile_" + orderItem) != null
								&& document.getElementById("orderdate_" + orderItem) != null
								&& "" != document.getElementById("orderdate_" + orderItem).innerText){
							$("#deliveryDateMsgMobile_" + orderItem).addClass("hide");
						}
					}				
				}
			}
		var orders1 = serviceResponse.shipMsgResAfterCutOff;
		for (var orderItem in orders1) {
			console.log( orderItem + "::  " +  orders1[orderItem] );
			console.log( "after cutoff "+orderItem + "::  " +  orders1[orderItem] );
			if (serviceResponse.fromPDP == 'Y') {
				if(document.getElementById("deliveryDateMsg") != null 
						&& null != document.getElementById("orderdate")
						&& "" != document.getElementById("orderdate").innerText){
					$("#deliveryDateMsg").removeClass("hide");
					}
				if (document.getElementById("ShippingMessage") != null) {
					$("#ShippingMessage").addClass("hide");
				}
			} else {
				if (document.getElementById("shippingMsgContainer_" + orderItem) != null) {
					$("#shippingMsgContainer_" + orderItem).addClass("hide");
				}
			}
		}
		if('Y' != serviceResponse.fromPDP){
			if (null != serviceResponse.hasOrderLevelMsg && true == serviceResponse.hasOrderLevelMsg 
					&& serviceResponse.orderLevelShippingMessage != null && document.getElementById("shippingMsgContainerSPC") != null) {
				console.log("hasOrderLevelMsg " +serviceResponse.hasOrderLevelMsg+" :: "+serviceResponse.orderLevelShippingMessage);
				productDisplayJS.hasOrdLevHollidayMsg = true;
				document.getElementById("shippingMsgContainerSPC").innerHTML = serviceResponse.orderLevelShippingMessage;
				$("#shippingMsgContainerSPC").addClass("sled-icon");
				$("#shippingMsgContainerSPC").removeClass("hide");
				if(document.getElementById("deliveryDateMsg_10552") != null
						&& document.getElementById("orderdate_10552") != null
						&& "" != document.getElementById("orderdate_10552").innerText){
					$("#deliveryDateMsg_10552").addClass("hide");
				}
				if(document.getElementById("deliveryDateMsg_10553") != null
						&& document.getElementById("orderdate_10553") != null
						&& "" != document.getElementById("orderdate_10553").innerText){
					$("#deliveryDateMsg_10553").addClass("hide");
				}
				if(document.getElementById("deliveryDateMsg_10554") != null
						&& document.getElementById("orderdate_10554") != null
						&& "" != document.getElementById("orderdate_10554").innerText){
					$("#deliveryDateMsg_10554").addClass("hide");
				}
			}else{
				productDisplayJS.hasOrdLevHollidayMsg = false;
				console.log("hasOrderLevelMsg :: "+serviceResponse.hasOrderLevelMsg);
				$("#shippingMsgContainerSPC").addClass("hide");
				if(document.getElementById("deliveryDateMsg_10552") != null
						&& document.getElementById("orderdate_10552") != null
						&& "" != document.getElementById("orderdate_10552").innerText){
					$("#deliveryDateMsg_10552").removeClass("hide");
				}
				if(document.getElementById("deliveryDateMsg_10553") != null
						&& document.getElementById("orderdate_10553") != null
						&& "" != document.getElementById("orderdate_10553").innerText){
					$("#deliveryDateMsg_10553").removeClass("hide");
				}
				if(document.getElementById("deliveryDateMsg_10554") != null
						&& document.getElementById("orderdate_10554") != null
						&& "" != document.getElementById("orderdate_10554").innerText){
					$("#deliveryDateMsg_10554").removeClass("hide");
				}
			}
		}
		productDisplayJS.holidayMsgCallCompleted = true;
	}
	,failureHandler: function(serviceResponse) {
		console.log("There was an error in getting holiday shipping method.");
	}
});
wc.service.declare({
	id: "AjaxRestrictedAddCart",
	actionId: "AjaxRestrictedAddCart",
	url: getAbsoluteURL() + "AjaxRestrictedAddCart",
	formId: ""
	,successHandler: function(serviceResponse) {
		console.log("Restricted::"+serviceResponse.isRestricted + ":: for SKU" +serviceResponse.sku );
		document.getElementById("restrictionMessage").innerHTML ="";		
			if (serviceResponse.isRestricted == 'Y') {				
				document.getElementById("restrictionMessage").innerHTML = "This product is not eligible to ship to your location";
				$("#restrictionMessage").addClass("out_of_stock");
				$("#restrictionMessage").addClass("show");
				$("#restrictionMessage").removeClass("hide");				
				productDisplayJS.disableAllButtoninpage();		
			} 
	}
	,failureHandler: function(serviceResponse) {
			document.getElementById("restrictionMessage").innerHTML ="";
				console.log("There was an error in getting  response from Drools from zipcode restrictions.");
	}
});
wc.service.declare({
	id: "AjaxInvokeDeliveryDateAPI",
	actionId: "AjaxInvokeDeliveryDateAPI",
	url: getAbsoluteURL() + "AjaxInvokeDeliveryDateAPI",
	formId: ""

	,successHandler: function(serviceResponse) {
		var catEntryId = serviceResponse.catEntryId;
		var displayDeliveryDateMsg = true;
		try{
			if(typeof(globalInventoryMap) != 'undefined' 
				&& globalInventoryMap[catEntryId].status != 'In-Stock'){
				console.log(serviceResponse.resolvedItem + " Item Out of Stock");
				displayDeliveryDateMsg = false;
			}
		}catch(err){
			console.log(err);
		}
		if(displayDeliveryDateMsg && typeof(serviceResponse.itemDeliveryDateMap) != 'undefined' ){
			try{
				resolvedItem = serviceResponse.resolvedItem
				itemDeliveryDate = serviceResponse.itemDeliveryDateMap;
				var dateTimeString =  itemDeliveryDate[resolvedItem];
				var months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
				var days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

								var dateTime = [];
				dateTime = dateTimeString.split("|");

									var deliveryDate = new Date(dateTime[0]);
				var cutoffTime =  new Date(dateTime[1]);
				var currentDate =  new Date();

				 				var dateDiff = cutoffTime.getDate() - currentDate.getDate();
				var dateString

								switch(dateDiff) {
				  case 0:
					  dateString= "Today";
				    break;
				  case 1:
					  dateString= "Tomorrow";
				    break;
				  default:
					  dateString= days[cutoffTime.getDay()];
				}


												if(cutoffTime.getHours() > 12){
					var time = cutoffTime.getHours() - 12;
					document.getElementById("orderdate").innerHTML = time + "pm " +  dateString;
				}else{
					document.getElementById("orderdate").innerHTML = cutoffTime.getHours() + "am " +  dateString;
				}

								document.getElementById("deliverydate").innerHTML = days[deliveryDate.getDay()] + ", " +months[deliveryDate.getMonth()]+ " " + deliveryDate.getDate();
				if("PDP" == serviceResponse.fromPage && document.getElementById("HolidayShipMsgFlag") != null && document.getElementById("HolidayShipMsgFlag").value == 'Y')
				{
					if(productDisplayJS.holidayMsgCallCompleted && productDisplayJS.holidayPreCutOff){
						$("#deliveryDateMsg").addClass("hide");
					}
					else{
						$("#deliveryDateMsg").removeClass("hide");
				 	}
				}else{
					$("#deliveryDateMsg").removeClass("hide");		
				}

								if(typeof(productDisplayJS) != "undefined" && typeof(productDisplayJS.inventoryMessages) != "undefined" ){
					productDisplayJS.deliverDateMessages = serviceResponse.itemDeliveryDateMap;
				}

						}catch(err){
				console.log(err);
			}
		}else{
			$("#deliveryDateMsg").addClass("hide");	
		}


							}

	,failureHandler: function(serviceResponse) {
		cursor_clear();
	}

});

wc.service.declare({
	id: "AjaxCouponIssue",
	actionId: "AjaxCouponIssue",
	url: "AjaxCouponIssue",
	formId: ""	
	,successHandler: function(serviceResponse) {
		if (serviceResponse.URL == 'PetcoRepeatDeliveryDetailsView'){
			redirectToDetailView('true');
		} else {
			$('#display-promo')[0].style.display='none';
			$('#promo-applied')[0].style.display='block';	
		}
	}	
	,failureHandler: function(serviceResponse) {
		if(document.getElementById("petcoCancelRepeatDeliveryArea") != null) {
			redirectToDetailView('false');
		} else {
			document.getElementById("rdaddon-coupon-error").innerHTML = '<font color="red">' + serviceResponse.errorMessage + '</font>';
			document.getElementById("rdaddon-coupon-error").style.display='block';
		}
	}
});

wc.service.declare({
	id: "AjaxAddRecommendedItemToCart",
	actionId: "AjaxAddRecommendedItemToCart",
	url: getAbsoluteURL() + "AjaxOrderChangeServiceItemAdd",
	formId: ""	
	,successHandler: function(serviceResponse) {
		setTimeout(function(){
			$('#mini-cart').css('visibility', 'visible');
			var miniCartActiveItem = "<div class=\"mini-cart-active-item\"><span class=\"glyphicon glyphicon-ok\"></span> Item successfully added to cart.</div>";
			$('.mini-cart-item').first().append(miniCartActiveItem);					
			setTimeout(function(){
				$('#mini-cart').css('visibility', 'hidden');
				$('div.mini-cart-active-item').remove();
			},3000);
		},1000);	

				if(document.getElementById("headerShopCartLink")&&document.getElementById("headerShopCartLink").style.display != "none") {
			document.getElementById("headerShopCart").focus();
		} else {
			if(document.getElementById("headerShopCart1")){
				document.getElementById("headerShopCart1").focus();
			}
		}
		dojo.require("dijit.registry");
		MessageHelper.hideAndClearMessage();			
		cursor_clear();
		if(shoppingActionsJS){				
			var attributes_container = dojo.query('div[id^="attrValue_"]');				
			if ((dojo.query(".definingAttributes")[0]) != null) {
				var attributes_container = dojo.query(".definingAttributes");	
			} else if ((dojo.query(".product_sizes")[0]) != null) {
				var attributes_container = dojo.query(".product_sizes");
			} else if ((dojo.query(".product_info")[0]) != null) {
				var attributes_container = dojo.query(".product_info");
			}

						var attributes = new Array();
			for (var i = 0; i < attributes_container.length; i++) {
				var attribute_selectors = attributes_container[i].querySelectorAll(".dijitSelect");
				for (var j = 0; j < attribute_selectors.length; j++) {
					attributes = attributes.concat(attribute_selectors[j]);
				}
			}

						var dijitSelect = new Array();
			for (var i = 0; i < attributes.length; i++) {
				dijitSelect[i] = dijit.registry.byNode(attributes[i]);
			}

							var singleSKU = true;
			for(var i=0; i<dijitSelect.length; i++){
				if (dijitSelect[i].options.length > 2) {
				singleSKU = false;
				}
			}
			if (!singleSKU) {
				shoppingActionsJS.selectedAttributes = new Object();
				dojo.topic.publish('DefiningAttributes_Resolved_'+shoppingActionsJS.baseCatalogEntryId, shoppingActionsJS.baseCatalogEntryId, -1);
				for(var i=0; i<dijitSelect.length; i++){
					if(dijitSelect[i] != null){
						dijitSelect[i].value = "";
					}
				}
			}				
		}
		if(typeof(ShipmodeSelectionExtJS)!= null && typeof(ShipmodeSelectionExtJS)!='undefined'){
			ShipmodeSelectionExtJS.setOrderItemId(serviceResponse.orderItemId[0]);
		}
		dojo.publish("CMAddToCart");			

				var omnitureEnabled;
		if(null != $('#omnitureEnabled') && undefined != $('#omnitureEnabled')) {
			omnitureEnabled = $('#omnitureEnabled').val();
		}	

				if(omnitureEnabled != "undefined" && null != omnitureEnabled && omnitureEnabled !='' && omnitureEnabled == 'true'){
			var cartEventDetails = {};
			var elementIdPrefix = document.getElementById("selectedRecommendationElement").value;
			var elementId = elementIdPrefix + "-addToCartBtn";
			var productNameTaggingElement =  elementIdPrefix + "-productName-tagging";
			var partNumberTaggingElement =  elementIdPrefix + "-partNumber-tagging";	
			var productName = "";
			var partNumber = "";
			var formattedProductName = "";
			if(document.getElementById(productNameTaggingElement) != undefined){
				productName = document.getElementById(productNameTaggingElement).value;
				formattedProductName = productName.replace(/["']/g, "");
			}
			if(document.getElementById(partNumberTaggingElement) != undefined){
				partNumber = document.getElementById(partNumberTaggingElement).value;
			}

						var cartOrderId = dojo.cookie("WC_CartOrderId_10151");
			if(cartOrderId == '' || cartOrderId == null || cartOrderId == 'undefined'){
				cartEventDetails["event_name"] = "cart_open";
				cartEventDetails["cart_id"] = serviceResponse.orderId[0];
			} else{
				cartEventDetails["event_name"] = "cart_add";
				cartEventDetails["cart_id"] = cartOrderId;
			}

						cartEventDetails["product_sku"] = partNumber;
			cartEventDetails["product_name"] = formattedProductName;
			cartEventDetails["add_to_cart_quantity"] = "1";
			cartEventDetails["product_delivery_type"] = "one time";		
			pushEvent(cartEventDetails,elementId);
		}
		var zipCode = "";
		if($("#isSDDeliveryEnabled").length > 0 && 'true' == $("#isSDDeliveryEnabled").val()){
			if(null != localStorage.getItem("USER_SET_ZIP")){
				zipCode= localStorage.getItem("USER_SET_ZIP");
			}else if(null != sessionStorage.getItem("USER_SET_ZIP")){
				zipCode= sessionStorage.getItem("USER_SET_ZIP");
			}
		}

				if(typeof(productDisplayJS) != "undefined" && document.getElementById("isCartInterstialEnabled") != undefined 
				&& document.getElementById("isCartInterstialEnabled") != null
				&& document.getElementById("isCartInterstialEnabled").value == 'Yes'){				
			var catentryId = productDisplayJS.getCatalogEntryId(productDisplayJS.baseCatalogEntryId);			
			document.location.href = getAbsoluteURL() +"PetcoAddToCartLandingPageView?langId=" + shoppingActionsServicesDeclarationJS.langId + "&catalogId=" + shoppingActionsServicesDeclarationJS.catalogId + "&storeId=" + shoppingActionsServicesDeclarationJS.storeId + "&catentryId=" + productDisplayJS.baseCatalogEntryId + "&selectCatentryId=" + catentryId + "&orderItemId=" + serviceResponse.orderItemId[0];
		}else{
			document.location.href = getAbsoluteURL() + "OrderCalculate?calculationUsageId=-1&calculationUsageId=-2&calculationUsageId=-7&calculationUsageId=-6&orderId=.&langId="+ shoppingActionsServicesDeclarationJS.langId + "&catalogId=" + shoppingActionsServicesDeclarationJS.catalogId + "&storeId=" + shoppingActionsServicesDeclarationJS.storeId +"&zipCode="+zipCode + "&sddOrderItem=" + serviceResponse.orderItemId[0] + "&errorViewName=AjaxOrderItemDisplayView&callToODM=true&updatePrices=1&URL=" + encodeURIComponent(getAbsoluteURL() + "OrderCalculate?calculationUsageId=-1&calculationUsageId=-7&orderId=.&langId="+ shoppingActionsServicesDeclarationJS.langId + "&catalogId=" + shoppingActionsServicesDeclarationJS.catalogId + "&storeId=" + shoppingActionsServicesDeclarationJS.storeId + "&errorViewName=AjaxOrderItemDisplayView&callToODM=false&updatePrices=1&URL="+encodeURIComponent(getAbsoluteURL() + "OrderItemDisplay?doInventory=Y&orderId=.&langId="+ shoppingActionsServicesDeclarationJS.langId + "&catalogId=" + shoppingActionsServicesDeclarationJS.catalogId + "&storeId=" + shoppingActionsServicesDeclarationJS.storeId));
		}
	}	
	,failureHandler: function(serviceResponse) {
		if (serviceResponse.errorMessage) {
			petcoCommonJS.showModalNotificationAlert(serviceResponse.errorMessage);
			cursor_clear();
			return false;
		} else {
			 if (serviceResponse.errorMessageKey) {
				MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
			 }
		}
		cursor_clear();
	}
});
